<template>
  <footer class="footer__wrapper">
    <div class="footer__content-wrapper">
      <footer-logo class="footer__logo" />
      <div class="footer__menu-list">
        <footer-menu-list :items="footerLeftSection" />
        <footer-menu-list :items="footerRightSection" />
      </div>
      <footer-follow-us-section :footer-socials="stayConnected" />
      <i class="footer__horizontal-divider" />
      <footer-bottom-text />
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'

import FooterLogo from './FooterLogo'
import FooterFollowUsSection from './FooterFollowUsSection'
import FooterBottomText from './FooterBottomText'
import FooterMenuList from './FooterMenuList'
import { serverCacheKey } from '@/utils/mixins/serverCacheKey'

export default {
  name: 'AmpFooter',
  mixins: [serverCacheKey],
  components: {
    FooterLogo,
    FooterFollowUsSection,
    FooterBottomText,
    FooterMenuList
  },
  computed: {
    ...mapGetters({
      footerLeftSection: 'footerLeftSection',
      footerRightSection: 'footerRightSection',
      stayConnected: 'stayConnected'
    })
  }
}
</script>

<style lang="scss" scoped>
.footer__wrapper {
  width: 100%;
  background: radial-gradient(
    100.91% 53.73% at 50% -10.14%,
    $c--main 0%,
    $c--black 100%
  );
  color: $c--white;
  margin-top: 20px;
  padding: 64px 24px;

  .footer__content-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    width: 100%;
    margin: 0 auto;
  }

  .footer__logo {
    max-width: 200px;
  }

  .footer__menu-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .footer__horizontal-divider {
    display: block;
    width: 100%;
    height: 1px;
    background: rgba($c--white, 0.25);
  }
}
</style>
